export type TWithChildren = {
  children?: TWithChildren[];
};

export const countTreeNodes = <T extends TWithChildren>(tree: T[]) =>
  tree.reduce(
    (count, node) =>
      node.children ? count + countTreeNodes(node.children) : count,
    tree.length
  );
